export const state = {
  sideBarOpen: true
}

export const getters = {
  g_sideBarOpen: (state) => state.sideBarOpen
}

export const mutations = {
  SET_SIDEBAR(state, payload) {
    state.sideBarOpen = payload
  },

  toggleSideBar(state) {
    state.sideBarOpen = !state.sideBarOpen
  },
}
